function sidebarDropdown() {
	const dropdown = document.querySelector('#sidebar-dropdown');

	if (dropdown) {
		dropdown.addEventListener('change', function (e) {
			e.preventDefault();
			window.location.href = e.target.value;
		});
	}
}

export { sidebarDropdown };
